import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const BusinessCoreSection = () => {
  const services = [
    {
      number: '01',
      tag: 'CORPORATE EXECUTIVE SANDBOX',
      title: '高端心智壓力測試沙盒工作坊',
      description: '為全球 500 強企業與金融機構設計，在 3 小時內模擬 40 年時空與資源流轉，精準捕捉高階經理人的決策盲點與風險防禦極限，優化 ESG 中的員工金錢心理健康指標。',
      badges: ['B2B', 'FORTUNE 500', 'ESG']
    },
    {
      number: '02',
      tag: 'GLOBAL FACILITATOR LICENSING PLATFORM',
      title: '全球引導師生態系認證與版權授權',
      description: '引進聯合國永續發展（SDGs／ESG）引導師機制。系統對齊國際標準，無縫接軌全球企業與教育單位，協助教練建立版權複利事業，打造國際社會影響力。',
      badges: ['SDGs', 'LICENSING', 'ESG']
    },
    {
      number: '03',
      tag: 'YOUTH LEADERSHIP & SUSTAINABLE EDUCATION',
      title: '新世代青年高能動性孵化計畫',
      description: '與各級學校、大專院校創新創業營隊及國際教育論壇合作，引導未來青年在科技高度發達與變局交織的時代，主動發起跨界合作、重塑生涯與未來的最高主導權。',
      badges: ['B2G', 'EDUCATION', 'YOUTH']
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="text-orange-400 text-sm font-medium tracking-wider mb-4">
              CORE SERVICES
            </div>
            <h2 className="text-4xl lg:text-5xl font-serif text-gray-900 mb-4">
              三大硬核商務版塊
            </h2>
            <p className="text-lg text-gray-600">
              從企業菁英到全球教練網絡、再到新世代青年——一套系統，三層放大。
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div 
                key={index}
                className="group bg-white rounded-2xl p-8 hover:shadow-2xl transition-all duration-300 border border-orange-100 hover:border-orange-300"
              >
                <div className="flex items-start justify-between mb-6">
                  <span className="text-5xl font-light text-orange-300">
                    {service.number}
                  </span>
                  <div className="w-10 h-10 rounded-full border-2 border-orange-200 flex items-center justify-center group-hover:bg-orange-500 group-hover:border-orange-500 transition-all duration-300">
                    <ArrowUpRight className="w-5 h-5 text-orange-500 group-hover:text-white transition-colors duration-300" />
                  </div>
                </div>

                <div className="mb-4">
                  <div className="text-xs text-orange-400 font-medium tracking-wider mb-3">
                    {service.tag}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>

                <div className="flex flex-wrap gap-2 mt-6">
                  {service.badges.map((badge, idx) => (
                    <span 
                      key={idx}
                      className="px-3 py-1 bg-orange-50 text-orange-600 text-xs font-medium rounded-full"
                    >
                      {badge}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessCoreSection;